@let _products = products();
@if (_products && _products!.length) {
  <div
    class="py-4 lg:py-8"
    [style.backgroundColor]="highlightCategoryBackgroundColor() | contentBuilderColor"
  >
    <app-product-card-list-atom
      displayContext="shop_page"
      [heading]="category()[categoryKeys.Name]"
      [description]="category()[categoryKeys.Description] ?? ''"
      [products]="_products"
      [isOrderingAllowed]="isOrderingAllowed()"
      [categoryNameColor]="$any(colorOrFallback(highlightCategoryNameColor(), categoryNameColor()))"
      [categoryDescriptionColor]="categoryDescriptionColor()"
      [productNameColor]="productNameColor()"
      [productDescriptionColor]="productDescriptionColor()"
      [productPriceColor]="productPriceColor()"
      [productImagePlaceholderColor]="productImagePlaceholderColor()"
      [productBorderColor]="productBorderColor()"
      [productBackgroundColor]="productBackgroundColor()"
      [productHoverColors]="productHoverColors()"
      (productClick)="onNavigateTo($event)"
    ></app-product-card-list-atom>
  </div>
}
